// extracted by mini-css-extract-plugin
export var chevron = "_j8-2";
export var dropdownItems = "_j8-0";
export var item = "_j8-1";